var exports = {
  "p": "xfd349460--dea680--list",
  "x": "xfd349460--dea680--list-item",
};

module.exports = exports;
